import { GzExchangeAntispamRulesFormWebComponent } from './component/GzExchangeAntispamRulesFormWebComponent';

export { GzExchangeAntispamRulesFormWebComponent };
